import { render, staticRenderFns } from "./ColorsGradientsSection.vue?vue&type=template&id=12897b6b"
import script from "./ColorsGradientsSection.vue?vue&type=script&lang=ts"
export * from "./ColorsGradientsSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsGradientsSection.vue?vue&type=style&index=0&id=12897b6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports